import { ACTIVE_STATUS_FILTER_POSTS, AGE_FILTER_POSTS, CONVERSATION_FILTER_POSTS, DATE_RANGE_FILTER_POSTS, FACE_STATUS_POST, FORM_FILLED_FILTER_POSTS, GENDER_FILTER_POSTS, GENDER_STATUS_FILTER_POSTS, IS_REJECTED_POST, LOCATION_FILTER_POSTS, RESET_FILTER_POSTS, SEARCH_FILTER_POSTS, SET_ACTIVE_FILTER_PAGE, STATUS_FILTER_POSTS, TYPE_FILTER_POSTS } from "./PostTypes";


export function setActiveFilterPage(pageKey) {
    return {
        type: SET_ACTIVE_FILTER_PAGE,
        payload: pageKey,
    };
}

export function serachFilterPost(data) {
    return {
        type: SEARCH_FILTER_POSTS,
        payload: data,
    };
}

export function ageFilterPost(data) {
    return {
        type: AGE_FILTER_POSTS,
        payload: data,
    };
}

export function locationFilterPost(data) {
    return {
        type: LOCATION_FILTER_POSTS,
        payload: data,
    };
}

export function genderFilterPost(data) {
    return {
        type: GENDER_FILTER_POSTS,
        payload: data,
    };
}

export function statusFilterPost(data) {
    return {
        type: STATUS_FILTER_POSTS,
        payload: data,
    };
}

export function formFilledFilterPost(data) {
    return {
        type: FORM_FILLED_FILTER_POSTS,
        payload: data,
    };
}

export function typeFilterPost(data) {
    return {
        type: TYPE_FILTER_POSTS,
        payload: data,
    };
}

export function isRejectedPost(data) {
    return {
        type: IS_REJECTED_POST,
        payload: data,
    };
}

export function faceStatusPost(data) {
    return {
        type: FACE_STATUS_POST,
        payload: data,
    };
}

export function activeStatusFilterPost(data) {
    return {
        type: ACTIVE_STATUS_FILTER_POSTS,
        payload: data,
    };
}

export function genderStatusFilterPost(data) {
    return {
        type: GENDER_STATUS_FILTER_POSTS,
        payload: data,
    };
}

export function resetFilterPost() {
    return {
        type: RESET_FILTER_POSTS,
    };
}

export function conversationFilterPost(data) {
    return {
        type: CONVERSATION_FILTER_POSTS,
        payload: data,
    };
}

export function dateRangeFilterPost(startDate, endDate) {
    return {
        type: DATE_RANGE_FILTER_POSTS,
        payload: { startDate, endDate },
    };
}